<template>
    <div class="card">
        <DataTable
            :value="data"
            v-model:selection="selectedProducts"
            v-model:filters="filterParams.filters"
            filterDisplay="row"
            paginator
            lazy
            :rows="filterParams.perPage"
            :rowsPerPageOptions="[50, 100, 200]"
            :total-records="total"
            :loading="loading"
            @page="onPage($event)"
            @filter="getData()"
            @sort="onSort($event)"
            class="customTable"
            @row-select-all="onSelectAllChange"
            @row-select="onRowSelect"
            @row-unselect="onRowUnselect"
        >
        <template #header>
            <div class="table-header">
                <h5 class="p-m-0">
                    Категорії товарів
                </h5>

                <div class="action_panel">
                    <a href="javascript:void(0);" @click="getExcel()">
                        <Button icon="pi pi-external-link" label="Викачати XLS" />
                    </a>
                </div>
            </div>
        </template>
            <Column selectionMode="multiple" :class="{'select-all-selected': selectAll}" headerStyle="width: 3rem"></Column>
            <Column field="name" header="Найменування">
                <template #body="slotProps">
                    <InputText class="price_input" v-model="slotProps.data.name" />
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.name.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="products_count" :sortable="true" header="К-сть товарів" headerStyle="width: 70px">
                <template #body="slotProps">
                    {{ slotProps.data.products_count }}
                </template>
            </Column>
            <Column field="" header="">
                <template #body="slotProps">
                    <div class="table-actions">
                        <a href="#" @click.prevent="() => {selectedProducts=[]; selectedProducts.push(slotProps.data); deleteProducts()}">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.26671 9.66683L0.333374 8.7335L4.06671 5.00016L0.333374 1.26683L1.26671 0.333496L5.00004 4.06683L8.73337 0.333496L9.66671 1.26683L5.93337 5.00016L9.66671 8.7335L8.73337 9.66683L5.00004 5.9335L1.26671 9.66683Z" fill="#B70D09"/>
                            </svg>
                        </a>
                    </div>
                </template>
            </Column>
            <template #footer>
                Всього {{ total }}
            </template>
        </DataTable>

        <div class="bottom_btns">
            <a href="javascript:void(0)" class="add_file_btn" @click="save()">Зберегти</a>
            <a href="javascript:void(0)" class="add_file_btn main" @click="isAddProducts=true">Додати нову категорію</a>
            <a href="javascript:void(0)" class="add_file_btn main" v-if="selectedProducts.length" @click="deleteProducts()">Видалити</a>
            <a href="javascript:void(0)" class="add_file_btn main disabled" v-else>Видалити</a>
            <a href="javascript:void(0)" class="add_file_btn main" v-if="selectedProducts.length > 1" @click="isMerge=true">Об’єднати</a>
            <a href="javascript:void(0)" class="add_file_btn main disabled" v-else>Об’єднати</a>
        </div>

        <Dialog v-model:visible="isAddProducts" id="items-table" header="Створення нової категорії" :style="{ width: '500px' }" modal :contentStyle="{ height: '150px' }">
            <div class="modal_main_content_container">
                <InputText class="price_input" placeholder="Назва" v-model="newProduct.name" />
                <p style="color: red; font-weight: bold;" v-if="msg">{{ msg }}</p>
            </div>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="addProducts()">Додати</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="() => {isAddProducts=false;msg=null;newProduct.name=null}">Відмінити</a>
                </div>
            </template>
        </Dialog>

        <Dialog v-model:visible="isMerge" id="items-table-2" :header="'Об\'єднати категорії'" :style="{ width: '500px' }" modal :contentStyle="{ height: '150px' }">
            <div class="modal_main_content_container">
                <Dropdown v-model="selectedCategoryToMerge" :options="selectedProducts" filter optionLabel="name" optionValue="id" placeholder="Оберіть основну категорію" />
                <p style="color: darkorange;">Після об'єднання, товари перейдуть в обрану категорію</p>
            </div>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" v-if="selectedCategoryToMerge" @click.prevent="merge()">Додати</a>
                    <a href="javascript:void(0)" class="confirm_button_cancel disabled" v-else>Додати</a>

                    <a href="#" class="confirm_button_confirm" @click.prevent="() => {isMerge=false}">Відмінити</a>
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "@/Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import {FilterMatchMode} from "primevue/api";
import Button from 'primevue/button';

export default {

    components: {
        DataTable,
        Column,
        InputText,
        swal,
        Dialog,
        Dropdown,
        Toast,
        Button,
    },
    layout: AppLayout,

    data() {
        return {
            data: [],
            allItems: [],
            total: 0,
            msg: null,
            selectedCategoryToMerge: null,
            selectedProducts: [],
            filterParams: {
                page: 1,
                order_by: null,
                order: 1,
                perPage: 50,
                filters: {
                    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                }
            },
            newProduct: {
                name: null,
            },
            loading: false,
            selectAll: false,
            isAddProducts: false,
            isMerge: false,
            viewVariants: [
                {
                    value: null,
                    name: 'Всі'
                },
                {
                    value: true,
                    name: 'Активні'
                },
                {
                    value: false,
                    name: 'Приховані'
                },
            ]
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        onSort(event) {
            this.filterParams.order_by = event.sortField
            this.filterParams.order = event.sortOrder
            
            this.getData()
        },
        save() {
            axios.post(this.route('api.catalog.product.producttypes.library.update'), {data: this.data}).then(result => {
                this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Типи товарів успішно оновлено', life: 3000 });
                this.getData()
            });
        },
        addProducts() {
            this.msg = null
            axios.post(this.route('api.catalog.product.producttypes.library.add'), this.newProduct).then(result => {
                if (result.data.error) {
                    this.msg = result.data.error
                } else {
                    this.newProduct = {
                        name: null,
                    }

                    this.isAddProducts = false
                    
                    this.getData()
                }
            }).catch((error) => {
                console.log(error)
            });
        },
        merge() {
            this.msg = null
            this.isMerge = false

            new swal({
                title: 'Підтвердіть дію',
                text: this.generateTransferMessage(this.selectedProducts, this.selectedCategoryToMerge),
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.selectedCategoryToMerge = null
                    this.selectedProducts = []
                    return
                }

                axios.post(this.route('api.catalog.product.producttypes.library.merge'), {from: this.selectedProducts, to: this.selectedCategoryToMerge}).then(result => {
                    this.selectedCategoryToMerge = null
                    this.selectedProducts = []
                    this.getData()
                }).catch((error) => {
                    console.log(error)
                });

            });
        },
        generateTransferMessage(categories, targetCategoryId) {
            const targetCategory = categories.find(cat => cat.id === targetCategoryId);
            if (!targetCategory) {
                return 'Цільова категорія не знайдена.';
            }

            // Отбираем категории-источники (все, кроме целевой)
            const sourceCategories = categories.filter(cat => cat.id !== targetCategoryId);

            const totalTransferred = sourceCategories.reduce(
                (sum, cat) => sum + (cat.products_count || 0),
                0
            );

            const sourceNames = sourceCategories.map(cat => `"${cat.name}"`).join(', ');
            const targetName = `"${targetCategory.name}"`;

            return `Товари (${totalTransferred} шт.) будуть перенесені з груп ${sourceNames} до групи ${targetName}. Групи ${sourceNames} будуть видалені.`;
        },
        getData() {
            this.loading = true
            axios.post(this.route('api.catalog.product.producttypes.get'), this.filterParams).then(result => {
                this.data = result.data.items.data;
                this.total = result.data.items.total;
                this.allItems = result.data.all;
                this.loading = false
            });
        },
        getExcel() {
            axios.post(this.route('api.catalog.product.producttypes.get-excel'), this.filterParams,
                {
                    responseType: 'blob'
                }
            )
            .then(function (result) {
                let blob = new Blob([result.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'categories-'+Date.now()+'.xlsx');
                document.body.appendChild(link);
                link.click();
            })
        },
        deleteProducts() {
            new swal({
                title: 'Ви впевнені?',
                text: 'Обрані групи будуть видалені',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.selectedProducts = []
                    return
                }

                axios.post(this.route('api.catalog.product.producttypes.library.delete'), {data: this.selectedProducts})
                    .then((result) => {
                        this.getData()
                        this.selectedProducts = []
                        this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Типи товарів успішно видалено', life: 3000 });
                    }).catch((error) => {
                        this.selectedProducts = []
                        console.log(error);
                        window.scroll(0, 0);
                    })

            });
        },
        onPage(event) {
            this.filterParams.page = event.page+1
            this.filterParams.perPage = event.rows
            this.getData()
        },
        onSelectAllChange() {
            if (this.data.length >= this.filterParams.perPage) {
                if (!this.selectAll) {
                    this.selectAll = true;
                    this.selectedProducts = this.data
                } else {
                    this.selectAll = false;
                    this.selectedProducts = [];
                }
            }
        },
        onRowSelect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = this.selectedProducts.length === this.data.length
            }
        },
        onRowUnselect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = false;
            }
        }
    }
};
</script>

<style scoped>
.bottom_btns {
    display: flex;
    gap: 16px;
    padding-top: 50px;
}
.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;
}
.add_file_btn.disabled, .confirm_button_cancel.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.add_file_btn.main {
    background-color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #000000;
    box-shadow: 0px 1px 2px 0px #0000004D;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.price_input {
    height: 40px!important;
    width: 100%;
    align-items: center;
    display: flex;
}
.check-text input {
  display: none;
}
.check-text svg {
  cursor: pointer;
}
.modal_main_content_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
</style>
